import { useState, useEffect } from "react";
import sendRequest from "hooks/useAxios";
import CardItemsContext from "./cardItems";
export default function CardItemsComponent(prop) {
  const [cardItemsState, setCardItemsState] = useState([]);

  useEffect(() => {
    sendRequest("Find_Cartitems", { conditions: "muid/=/1" }).then(({ data }) => {
      setCardItemsState(data);
    });
  }, []);

  return <CardItemsContext.Provider value={cardItemsState}>{prop.children}</CardItemsContext.Provider>;
}
